const REDESIGN_SELECTOR = '.motogp-redesign'
const RESET_SELECTOR = `${REDESIGN_SELECTOR} .reset, ${REDESIGN_SELECTOR} #packages-filter > button`

const productItems = () => document.querySelectorAll(`${REDESIGN_SELECTOR} .product-item`)

const checkedFiltersByGroup = () => {
  const groups = new Map()
  document.querySelectorAll(`${REDESIGN_SELECTOR} li[data-filter] input[type=checkbox]:checked`).forEach((input) => {
    const item = input.closest('li')
    groups.set(item.parentElement, [...(groups.get(item.parentElement) || []), item.dataset.filter])
  })
  return Array.from(groups.values())
}

const matchesFilters = (item, groups) => {
  const categories = (item.dataset.categoryNames || '').split(',')
  return groups.every((filters) => filters.some((filter) => categories.includes(filter)))
}

const filterByCategory = () => {
  const groups = checkedFiltersByGroup()
  productItems().forEach((item) => {
    const hidden = !matchesFilters(item, groups)
    item.parentElement.classList.toggle('pkg-hidden', hidden)
    item.closest('.seatingChartPackage')?.classList.toggle('pkg-hidden', hidden)
  })
}

const filterByPrice = () => {
  const min = parseInt(document.querySelector(`${REDESIGN_SELECTOR} .slider__min-slider`).value)
  const max = parseInt(document.querySelector(`${REDESIGN_SELECTOR} .slider__max-slider`).value)
  productItems().forEach((item) => {
    const price = parseInt(item.dataset.price)
    item.closest('.seatingChartPackage')?.classList.toggle('hidden', !(price >= min && price <= max))
  })
}

const sortByPrice = (direction) => {
  const items = Array.from(productItems())
    .sort((a, b) => parseFloat(a.dataset.price) - parseFloat(b.dataset.price))
  if (direction == 'htol') items.reverse()

  items.forEach((item) => {
    const wrapper = item.closest('.seatingChartPackage')
    wrapper?.parentElement.append(wrapper)
  })
}

const resetSliders = () => {
  const min = document.querySelector(`${REDESIGN_SELECTOR} .slider__min-slider`)
  const max = document.querySelector(`${REDESIGN_SELECTOR} .slider__max-slider`)
  if (!min || !max) return

  min.value = min.min
  max.value = max.max
  min.dispatchEvent(new Event('input', { bubbles: true }))
  max.dispatchEvent(new Event('input', { bubbles: true }))
}

const priceRangeNarrowed = () => {
  const min = document.querySelector(`${REDESIGN_SELECTOR} .slider__min-slider`)
  const max = document.querySelector(`${REDESIGN_SELECTOR} .slider__max-slider`)
  return !!min && !!max && (Number(min.value) !== Number(min.min) || Number(max.value) !== Number(max.max))
}

const updateResetButton = () => {
  const filtered = priceRangeNarrowed() || checkedFiltersByGroup().length > 0
  document.querySelectorAll(RESET_SELECTOR).forEach((button) => {
    button.classList.toggle('disabled', !filtered)
  })
}

const resetFilters = () => {
  document.querySelectorAll(`${REDESIGN_SELECTOR} li[data-filter] input[type=checkbox]`).forEach((input) => {
    input.checked = false
  })
  filterByCategory()
  resetSliders()
  productItems().forEach((item) => {
    item.closest('.seatingChartPackage')?.classList.remove('hidden')
  })
  updateResetButton()
}

document.addEventListener('turbo:load', () => {
  filterByCategory()
  updateResetButton()
})

const togglePackagesFilter = (open) => {
  document.querySelector(`${REDESIGN_SELECTOR} #packages-filter`)?.classList.toggle('show', open)
}

document.addEventListener('click', ({ target }) => {
  if (!(target instanceof Element)) return

  if (target.closest(RESET_SELECTOR)) resetFilters()
  else if (target.closest(`${REDESIGN_SELECTOR} .btn-filter`)) togglePackagesFilter(true)
  else if (target.closest(`${REDESIGN_SELECTOR} #packages-filter .btn-close`)) togglePackagesFilter(false)
})

document.addEventListener('change', ({ target }) => {
  if (!(target instanceof Element)) return

  if (target.matches(`${REDESIGN_SELECTOR} li[data-filter] input[type=checkbox]`)) {
    filterByCategory()
    updateResetButton()
  } else if (target.matches(`${REDESIGN_SELECTOR} .slider__min-slider, ${REDESIGN_SELECTOR} .slider__max-slider`)) {
    filterByPrice()
    updateResetButton()
  } else if (target.matches(`${REDESIGN_SELECTOR} .sorting-wrapper .sort select`) &&
             ['htol', 'ltoh'].includes(target.value)) {
    sortByPrice(target.value)
  }
})
